import {Injectable, OnInit} from '@angular/core';
import {Http} from "@angular/http";

@Injectable()
export class ConfigService implements  OnInit {

  private configData: any;

  constructor(private _http: Http) {
  }

  public ngOnInit() {
    this._http.get("/asset/text/lang-it.yml");
  }

}



// WEBPACK FOOTER //
// ./src/app/config/config.service.ts